import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'

@Component({
    selector: 'gd-type-editor-type-of-firm',
    templateUrl: './type-editor-type-of-firm.component.html',
    styleUrls: ['./type-editor-type-of-firm.component.scss'],
    imports: [
      CommonModule,
      KENDO_GRID,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        TextBoxDirective,
        FormsModule,
        ReactiveFormsModule,
        CellTemplateDirective,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
    ]
})
export class TypeEditorTypeOfFirmComponent extends GridEditorBaseComponent {
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  initGrid(): void {
    this.typesService.getTypesOfFirms().subscribe((response) => {
      this.repState.typesOfFirms = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const typeOfFirm = formGroup.value
    this.typesService.submitTypeOfFirmUpdate(typeOfFirm).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        typeOfFirmId: 0,
        typeDescription: null,
        active: true,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(typeOfFirm: any): UntypedFormGroup {
    return this.formBuilder.group({
      typeOfFirmId: typeOfFirm.typeOfFirmId,
      typeDescription: [typeOfFirm.typeDescription, Validators.required],
      active: typeOfFirm.active,
    })
  }
}
